module.exports = __webpack_public_path__ + "media/96.29e1c5de.mp3";